import React, { useMemo, useState } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeContext } from '../theme.context';
import { Themes } from '../theme.models';
import settings from '../theme.settings';
const ThemeProvider = (props) => {
    const { children, theme } = props;
    const [currentTheme, setCurrentTheme] = useState(settings[theme || Themes.VODAFONE_WS2]);
    const updateTheme = (newTheme) => {
        setCurrentTheme(settings[newTheme]);
    };
    const value = useMemo(() => {
        return { setCurrentTheme: updateTheme, settings: currentTheme };
    }, [currentTheme]);
    return (React.createElement(ThemeContext.Provider, { value: value },
        React.createElement(StyledThemeProvider, { theme: currentTheme.style }, children instanceof Function ? children(currentTheme) : children)));
};
export default ThemeProvider;
//# sourceMappingURL=theme-provider.js.map